import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import dayjs from "dayjs"
import { AxisTypeEnum } from "../../common/enum/axisType.enum"
import { ChartEnum } from "../../common/enum/chart.enum"
import { ChartTypeEnum } from "../../common/enum/chartType.enum"
import { FilterChartGUIInterface } from "../../common/interfaces/filterChartGUI.interface"
import { FilterChartSearchConditionInterface } from "../../common/interfaces/filterChartSearchCondition.interface"
import { getMaxDateChart } from "../../common/helper/date.helper"
import { defaultApp, defaultProvince } from "../../common/variables/filterChart"

export interface ChartUsingWalletState {
   requesting: boolean
   excelExporting: boolean
   error: string
   successful: boolean
   filter: FilterChartGUIInterface
   searchCondition: FilterChartSearchConditionInterface
   data: any[]
}

const initialState: ChartUsingWalletState = {
   requesting: false,
   excelExporting: false,
   error: "",
   successful: false,
   filter: {
      chartType: ChartTypeEnum.SIN,
      axisType: AxisTypeEnum.VERTICAL,
   },
   searchCondition: {
      type: ChartEnum.NONE,
      fromDate: dayjs(getMaxDateChart()),
      toDate: dayjs(getMaxDateChart()),
      app: [defaultApp],
      province: [defaultProvince],
   },
   data: [],
}

export const chartUsingWalletSlice = createSlice({
   name: "chartUsingWallet",
   initialState,
   reducers: {
      requestChartUsingWallet: (state: ChartUsingWalletState) => {
         state.requesting = true
      },
      getChartUsingWalletSuccess: (
         state: ChartUsingWalletState,
         action: PayloadAction<any>
      ) => {
         state.requesting = false
         state.successful = true
         state.error = ""
         state.data = action.payload
      },
      getChartUsingWalletFail: (
         state: ChartUsingWalletState,
         action: PayloadAction<any>
      ) => {
         state.requesting = false
         state.successful = false
         state.error = action.payload
         state.data = []
      },
      changeFilter: (
         state: ChartUsingWalletState,
         action: PayloadAction<any>
      ) => {
         state.filter = { ...state.filter, ...action.payload }
      },
      changeSearchCondtion: (
         state: ChartUsingWalletState,
         action: PayloadAction<any>
      ) => {
         if (
            action.payload.type === ChartEnum.APP ||
            action.payload.type === ChartEnum.PROVINCE
         ) {
            state.filter.chartType = ChartTypeEnum.BAR
            state.filter.axisType = AxisTypeEnum.VERTICAL
         }

         if (
            action.payload.type === ChartEnum.DAY ||
            action.payload.type === ChartEnum.MONTH ||
            action.payload.type === ChartEnum.YEAR
         ) {
            state.filter.chartType = ChartTypeEnum.SIN
         }

         if (action.payload.type) {
            state.searchCondition.fromDate = dayjs(getMaxDateChart())
            state.searchCondition.toDate = dayjs(getMaxDateChart())
         }

         state.data = []
         state.searchCondition = { ...state.searchCondition, ...action.payload }
      },
      startExportExcelChartUsingWallet: (state: ChartUsingWalletState) => {
         state.excelExporting = true
      },
      finishExportExcelChartUsingWallet: (state: ChartUsingWalletState) => {
         state.excelExporting = false
      },
   },
})

export const {
   requestChartUsingWallet,
   getChartUsingWalletSuccess,
   getChartUsingWalletFail,
   changeFilter,
   changeSearchCondtion,
   startExportExcelChartUsingWallet,
   finishExportExcelChartUsingWallet,
} = chartUsingWalletSlice.actions

export default chartUsingWalletSlice.reducer
